/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoRegistryOfficeCreate } from '../../models/dto-registry-office-create';
import { RegistryOfficeItem } from '../../models/registry-office-item';

export interface OfficeControllerCreate$Params {
      body: DtoRegistryOfficeCreate
}

export function officeControllerCreate(http: HttpClient, rootUrl: string, params: OfficeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryOfficeItem;
      }>;
    })
  );
}

officeControllerCreate.PATH = '/registry/office';
